import React from "react";
import { useLocation } from "react-router-dom";

const PAGES = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Keystone Shield Insurance respects your privacy. This policy explains how we collect, use, and protect the information you provide when requesting a quote or contacting us.",
      "Information we collect: contact details (name, phone, email, ZIP), and insurance-related information you voluntarily provide to help us prepare a quote. We do not collect Social Security numbers, payment card, banking information, or driver's-license images through this website.",
      "How we use it: to prepare insurance quotes, respond to your inquiry, and contact you about coverage options. We do not sell your personal information.",
      "SMS consent: by providing your phone number and submitting a form, you consent to receive calls and text messages from Keystone Shield Insurance regarding your insurance inquiry. Message and data rates may apply. Reply STOP to opt out.",
      "Email consent: by providing your email, you consent to receive email communications regarding your inquiry. You may unsubscribe at any time.",
      "Data security: we use secure connections and industry-standard practices to protect your information.",
      "Contact us to request access to or deletion of your information.",
    ],
  },
  terms: {
    title: "Terms of Use",
    body: [
      "By using this website you agree to these terms. This site provides general information and a means to request insurance quotes.",
      "No guarantee: quotes, coverage, eligibility, and rates are determined by the insurance carriers and are not guaranteed. Nothing on this site constitutes an offer or binding of coverage.",
      "Accuracy: you agree to provide accurate information. Coverage decisions are subject to underwriting.",
      "Communications: by submitting a form you agree to be contacted regarding your insurance inquiry.",
      "This website and its content are provided 'as is' without warranties. Keystone Shield Insurance is not liable for reliance on general information provided here.",
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const key = pathname.includes("terms") ? "terms" : "privacy";
  const p = PAGES[key];
  return (
    <div className="max-w-3xl mx-auto px-5 py-16">
      <h1 className="font-display text-4xl font-black mb-8" data-testid="legal-title">{p.title}</h1>
      <div className="space-y-5 text-slate-700 leading-relaxed">
        {p.body.map((t, i) => <p key={i}>{t}</p>)}
      </div>
    </div>
  );
}
